import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CONTRIBUTOR_DIALOG_FIELD_BLURRED,
  CONTRIBUTOR_DIALOG_FIELD_CHANGED,
  CONTRIBUTOR_DIALOG_ROLE_CHANGED,
  HIDE_CONTRIBUTOR_DIALOG,
  SAVE_ADD_CONTRIBUTOR,
} from "file-details/fileDetailsActions";
import {
  getAddContributorDialogVisible,
  getContributorDialogErrors,
  getContributorDialogFields,
  getProjectContributorRoles,
} from "common/selectors";
import ContributorDialog from "general-components/ContributorDialog";
import { useTranslation } from "react-i18next";

const AddContributorDialog = () => {
  const { t } = useTranslation();
  const errors = useSelector(getContributorDialogErrors);
  const fields = useSelector(getContributorDialogFields);
  const visible = useSelector(getAddContributorDialogVisible);

  const contributorRoles = useSelector(getProjectContributorRoles);

  const dispatch = useDispatch();
  const onBlur = (field, value) => () =>
    dispatch({ type: CONTRIBUTOR_DIALOG_FIELD_BLURRED, field, value });
  const onCancel = () => dispatch({ type: HIDE_CONTRIBUTOR_DIALOG });
  const onRoleChange = (event, role) =>
    dispatch({ type: CONTRIBUTOR_DIALOG_ROLE_CHANGED, role });
  const onSave = id => dispatch({ type: SAVE_ADD_CONTRIBUTOR });
  const onFieldChange = path => event => {
    const value = event.target.value;
    dispatch({ type: CONTRIBUTOR_DIALOG_FIELD_CHANGED, path, value });
  };

  return (
    <ContributorDialog
      title={t("file_details_add_contributor")}
      contributorRoles={contributorRoles}
      errors={errors}
      fields={fields}
      onBlur={onBlur}
      onCancel={onCancel}
      onFieldChange={onFieldChange}
      onRoleChange={onRoleChange}
      onSave={onSave}
      visible={visible}
    />
  );
};

export default AddContributorDialog;
